/**
 * Mimic unity enum type
 */
export function Enum(items = [], name = "") {
    let res = {};
    for (let i = 0; i < items.length; i++) {
        Object.defineProperty(res, String(items[i]), {
            configurable: false,
            writable: false,
            enumerable: true,
            value: i
        });
        Object.defineProperty(res, String(i), {
            configurable: false,
            writable: false,
            enumerable: false,
            value: String(items[i])
        });
    }
    if (name) {
        // XXX: For debug purposes to use values in console
        window[name] = window[name] || res;
    }
    return res;
}
